import OrdersGridWithDetail from "./OrdersGridWithDetail";
export default OrdersGridWithDetail;
